import { authClient } from '../../lib/authClient';
import logo from '../../logo-black.png';
import { Image } from '@mantine/core';
import React, { Suspense } from 'react';

export const UnauthenticatedLayout: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { data: session } = authClient.useSession();

  if (session?.session || session?.user) {
    return null;
  }

  return (
    <div className="waves absolute inset-0 overflow-y-scroll flex flex-col items-center gap-2">
      <Image
        className="w-[200px] mt-5"
        src={logo}
      />
      <div className="grow flex flex-col justify-center w-full">
        <Suspense fallback={null}>{children}</Suspense>
      </div>
    </div>
  );
};
